import React from 'react'
import Success from '../components/Success/Success'

const Successs = () => {
  return (
    <div>
        <Success/>
    </div>
  )
}

export default Successs